// extracted by mini-css-extract-plugin
module.exports = {"container":"p_c"};